import type { ResultadoPregunta } from '../api/tipos';
import { SERIE } from '../lib/personas';

function colorDeFila(indice: number, ganadora: boolean, esConteo: boolean): string {
  if (esConteo) return '#2B90CF';
  if (ganadora) return '#A1C623';
  return SERIE[indice % SERIE.length] ?? '#2B90CF';
}

interface Props {
  resultados: ResultadoPregunta[];
  compacto?: boolean;
}

export function Resultados({ resultados, compacto = false }: Props) {
  if (resultados.length === 0) {
    return <p className="text-[12.5px] text-mudo">Este evento no tiene preguntas de votación.</p>;
  }

  return (
    <div className={`flex flex-col ${compacto ? 'gap-4' : 'gap-6'}`}>
      {resultados.map((resultado) => {
        const esConteo = resultado.tipo === 'CHECK';

        return (
          <div key={resultado.preguntaId}>
            <div className="mb-2.5 flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
              <span
                className={`font-titulo font-bold text-titulo ${compacto ? 'text-[13.5px]' : 'text-base'}`}
              >
                {resultado.etiqueta}
              </span>
              <span className="text-xs text-debil">{resultado.subtitulo}</span>
              {resultado.privada && (
                <span className="rounded border border-cian/40 px-1.5 py-px text-[10px] uppercase tracking-[.6px] text-cian">
                  Solo admin
                </span>
              )}
            </div>

            <div className="flex flex-col gap-2">
              {resultado.filas.map((fila, indice) => (
                <div key={`${resultado.preguntaId}-${indice}`}>
                  <div className="mb-1 flex justify-between gap-3 text-[12.5px]">
                    <span className="min-w-0 truncate text-cuerpo">{fila.etiqueta}</span>
                    <span className="flex-none text-debil">{fila.conteo}</span>
                  </div>
                  <div
                    className={`overflow-hidden rounded-md bg-white/[.07] ${compacto ? 'h-2' : 'h-2.5'}`}
                  >
                    <div
                      className="h-full rounded-md transition-[width] duration-500"
                      style={{
                        width: `${fila.ancho}%`,
                        background: colorDeFila(indice, fila.ganadora, esConteo),
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-2 text-xs text-lima">{resultado.pie}</p>
          </div>
        );
      })}
    </div>
  );
}
